import validate from "/home/runner/work/ticketco-tickets/ticketco-tickets/node_modules/nuxt/dist/pages/runtime/validate.js";
import maintenance_45page_45global from "/home/runner/work/ticketco-tickets/ticketco-tickets/middleware/maintenance-page.global.js";
import route_45update_45global from "/home/runner/work/ticketco-tickets/ticketco-tickets/middleware/route-update.global.js";
import manifest_45route_45rule from "/home/runner/work/ticketco-tickets/ticketco-tickets/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  maintenance_45page_45global,
  route_45update_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}